import { Dialog, RadioGroup, Transition } from '@headlessui/react';
import { ClockIcon } from '@heroicons/react/20/solid';
import classNames from 'classnames';
import React, { Fragment, useState } from 'react';

function ScheduleVenueDialog(props) {

  const scheduleList = [
    {
      newSlot: true,
      name: "08:00 - 10:00",
      timeStart: "08:00:00",
      timeEnd: "10:00:00",
      isAvailable: true
    },
    {
      newSlot: true,
      name: "10:00 - 12:00",
      timeStart: "10:00:00",
      timeEnd: "12:00:00",
      isAvailable: true
    },
    {
      newSlot: true,
      name: "12:00 - 14:00",
      timeStart: "12:00:00",
      timeEnd: "14:00:00",
      isAvailable: true
    },
    {
      newSlot: true,
      name: "14:00 - 16:00",
      timeStart: "14:00:00",
      timeEnd: "16:00:00",
      isAvailable: true
    },
    {
      newSlot: true,
      name: "16:00 - 18:00",
      timeStart: "16:00:00",
      timeEnd: "18:00:00",
      isAvailable: true
    },
    {
      newSlot: true,
      name: "18:00 - 20:00",
      timeStart: "18:00:00",
      timeEnd: "20:00:00",
      isAvailable: true
    },
    {
      newSlot: true,
      name: "20:00 - 22:00",
      timeStart: "20:00:00",
      timeEnd: "22:00:00",
      isAvailable: true
    },
    {
      newSlot: true,
      name: "22:00 - 24:00",
      timeStart: "22:00:00",
      timeEnd: "24:00:00",
      isAvailable: true
    },
  ]
  const inputClass = "w-full text-xs bg-gray-100 rounded-lg py-2.5 px-6 "


  const [open, setOpen] = useState(false)
  const [selectedSchedule, setSelectedSchedule] = useState([])

  function closeModal() {
    setOpen(false)
  }

  function openModal() {
    setOpen(true)
  }

  const onScheduleSelected = (schedule) => {
    const selectedSchedules = [...selectedSchedule]
    const existIndex = selectedSchedules.findIndex(e => e.name == schedule.name)

    if (existIndex >= 0) {

      selectedSchedules.splice(existIndex, 1)

    } else {
      selectedSchedules.push(schedule)
    }

    setSelectedSchedule(selectedSchedules)
    props.onSlotsSelected(selectedSchedules)

  }

  const checkSchedule = (schedule) => {
    return (selectedSchedule.length > 0) && (selectedSchedule.filter((e) => e.name == schedule.name).length > 0)
  }


  return (
    <div className='flex-grow w-full'>

      <div className="flex items-center justify-center">


        <label onClick={openModal} className="relative w-full flex text-gray-400 focus-within:text-gray-600 ">
          <ClockIcon className='w-6 bg-gray-400 p-1 rounded-lg absolute top-1/2 transform -translate-y-1/2 left-3 text-white' />
          <button type="text" className={"pl-12 justify-start flex " + inputClass} >
            <p className='text-left'>
              {
                selectedSchedule.length == 0 ?
                  "Input Waktu Tersedia"
                  :
                  selectedSchedule.map((item) => {
                    return (
                      <>[{item.name}] &nbsp; </>
                    )
                  })
              }
            </p>
          </button>
        </label>

      </div>

      <Transition appear show={open} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">



                  <RadioGroup value={scheduleList} onChange={onScheduleSelected} className="mt-4">
                    <RadioGroup.Label className="sr-only"> Choose a size </RadioGroup.Label>


                    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 px-8">
                      {scheduleList.map((schedule) => (
                        <RadioGroup.Option
                          key={schedule.name}
                          value={schedule}
                          disabled={!schedule.isAvailable}
                          className={({ active }) =>
                            classNames(
                              schedule.isAvailable
                                ? ' cursor-pointer bg-white text-gray-900 shadow-sm '
                                : ' cursor-not-allowed bg-gray-50 text-gray-400 ',
                              ' group relative flex items-center justify-center rounded-md border py-3 px-4 text-sm font-medium uppercase hover:bg-lightYellow focus:outline-none sm:flex-1 '
                            )
                          }
                        >
                          {({ active, checked }) => (
                            <>
                              <RadioGroup.Label className="z-40" as="span">{schedule.name}</RadioGroup.Label>
                              {schedule.isAvailable ? (
                                <span
                                  className={classNames(
                                    ' border-2 ',
                                    checkSchedule(schedule) ? ' border border-amber-500 bg-amber-100 ' : ' border-transparent ',
                                    ' pointer-events-none absolute -inset-px rounded-md z-30 '
                                  )}
                                  aria-hidden="true"
                                />
                              ) : (
                                <span
                                  aria-hidden="true"
                                  className="pointer-events-none absolute -inset-px rounded-md border-2 border-gray-300"
                                >
                                  <svg
                                    className="absolute inset-0 h-full w-full stroke-2 text-gray-300"
                                    viewBox="0 0 100 100"
                                    preserveAspectRatio="none"
                                    stroke="currentColor"
                                  >
                                    <line x1={0} y1={100} x2={100} y2={0} vectorEffect="non-scaling-stroke" />
                                  </svg>
                                </span>
                              )}
                            </>
                          )}
                        </RadioGroup.Option>
                      ))}
                    </div>

                  </RadioGroup>

                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>


    </div>
  );
}

export default ScheduleVenueDialog;